export default {
  title: 'Il tuo sito web è pronto',
  body_one: 'Le prenotazioni sono ancora disattivate per {{count}} ristorante:',
  body_other: 'Le prenotazioni sono ancora disattivate per {{count}} ristoranti:',
  reasons: {
    license_required: 'Richiede un Partner Plan',
    notification_email_required:
      'Serve un indirizzo e-mail per le notifiche delle prenotazioni. Aggiungilo quando attivi le prenotazioni.',
    switched_off: 'Disattivato nelle impostazioni di prenotazione',
    activation_failed: 'Impossibile attivare. Riprova nelle impostazioni prenotazioni.',
  },
  buttons: {
    open_settings: 'Apri impostazioni prenotazioni',
    continue: 'Continua verso il website builder',
  },
};
